import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { IngredienteProdutoViewModel } from 'src/app/shared/models/produto.model';

@Component({
  selector: 'app-ingredientes-produto',
  templateUrl: './ingredientes-produto.component.html',
  styleUrls: ['./ingredientes-produto.component.scss']
})
export class IngredientesProdutoComponent {
  @Input() ingredienteCtrl!: FormControl;
  @Input() ingredientesFiltrados!: Observable<IngredienteProdutoViewModel[]>;
  @Input() ingredientesAdicionados: IngredienteProdutoViewModel[] = [];
  @Input() carregando: boolean = false;
  @Input() enviando: boolean = false;

  @Output() addIngrediente = new EventEmitter<any>();
  @Output() selectedIngrediente = new EventEmitter<MatAutocompleteSelectedEvent>();
  @Output() removerIngrediente = new EventEmitter<IngredienteProdutoViewModel>();

  public onAddIngrediente(event: any): void {
    this.addIngrediente.emit(event);
  }

  public onSelectedIngrediente(event: MatAutocompleteSelectedEvent): void {
    this.selectedIngrediente.emit(event);
  }

  public onRemoverIngrediente(ingrediente: IngredienteProdutoViewModel): void {
    this.removerIngrediente.emit(ingrediente);
  }
}